export const FULLSCREEN_CHANGE_EVENTS: string[] = [
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'fullscreenchange',
  'MSFullscreenChange',
]
